webpackJsonp([394],{

/***/ "/Fjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_compat__ = __webpack_require__("AQ6k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("jYI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HOC_withBaseComponent__ = __webpack_require__("Cq9c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_permissions__ = __webpack_require__("P6ry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_bicAction__ = __webpack_require__("KOqX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_bicAction_actionType__ = __webpack_require__("C3nP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actionTypes__ = __webpack_require__("9vGq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_lenderTheme__ = __webpack_require__("rHRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__("DHvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_navBarConfigAction__ = __webpack_require__("eGlY");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */













var BicContainer = Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["lazy"])(function () {
  return __webpack_require__.e/* import() */(323).then(__webpack_require__.bind(null, "C2kN"));
});
var BicRevampContainer = Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["lazy"])(function () {
  return __webpack_require__.e/* import() */(323).then(__webpack_require__.bind(null, "f9TL"));
});

var BuyWithInstacredLandingPage = function (_Component) {
  _inherits(BuyWithInstacredLandingPage, _Component);

  function BuyWithInstacredLandingPage() {
    var _temp, _this, _ret;

    _classCallCheck(this, BuyWithInstacredLandingPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.pageKey = 'pv_buy_with_instacred_home_bic', _this.campaignId = _this.props.matches.utm_campaign || '', _this.lenderId = Object(__WEBPACK_IMPORTED_MODULE_8__utils_lenderTheme__["c" /* getStorageLenderId */])(), _this.metadata = { campaign_id: _this.campaignId, lender_id: _this.lenderId }, _this.getBicData = function (shouldFetchApi) {
      var _ref = _this.props || {},
          bicAction = _ref.bicAction,
          lenderId = _ref.lenderId;

      var _ref2 = _this.props.matches || {},
          utmCampaign = _ref2.utm_campaign,
          queryParamUserUuid = _ref2.u;

      var _ref3 = _this.props.matches || {},
          merchantHandle = _ref3.merchantHandle;

      if (!utmCampaign) {
        utmCampaign = lenderId;
      }
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* setLocalStorage */])('utmCampaign', utmCampaign || '');
      bicAction(__WEBPACK_IMPORTED_MODULE_6__actions_bicAction_actionType__["a" /* default */].initializeBIC, {
        shouldFetchApi: shouldFetchApi,
        campaignId: utmCampaign,
        merchantHandle: merchantHandle,
        queryParamUserUuid: queryParamUserUuid
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  BuyWithInstacredLandingPage.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var apiState = true;
    if (this.props.apiState === __WEBPACK_IMPORTED_MODULE_7__actionTypes__["i" /* apiStatus */].SUCCESS) {
      var _ref4 = this.props || {},
          oldCampaignId = _ref4.campaignId,
          oldMerchantHandle = _ref4.merchantHandle;

      var _ref5 = this.props.matches || {},
          merchantHandle = _ref5.merchantHandle,
          utmCampaign = _ref5.utm_campaign;

      apiState = !(oldMerchantHandle === merchantHandle && oldCampaignId === utmCampaign);
    }
    this.props.navBarConfigAction(__WEBPACK_IMPORTED_MODULE_7__actionTypes__["z" /* navBarConfigActionType */].SET_CONFIG, {
      showDesktopNavMenu: true,
      showDesktopSearchBar: true,
      showBackBtn: false,
      showMobileSearchIcon: true
    });
    this.getBicData(apiState);
    if (!__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* default */].isOrganicSite()) {
      setTimeout(function () {
        new __WEBPACK_IMPORTED_MODULE_4__utils_permissions__["a" /* default */](_this2.pageKey).askForPushNotification();

        var _ref6 = window.addToHomeScreenObject || {},
            prompt = _ref6.prompt;

        var hidePrompt = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* getLocalstorage */])('hideAddToHomeScreenPrompt');
        _this2.setState({
          showAddToHomeScreenPrompt: prompt && !hidePrompt
        });
      }, 3000);
    }
  };

  BuyWithInstacredLandingPage.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    var _ref7 = previousProps.matches || {},
        prevUtmCampaign = _ref7.utm_campaign,
        prevMerchantHandle = _ref7.merchantHandle;

    var _ref8 = this.props.matches || {},
        utmCampaign = _ref8.utm_campaign,
        merchantHandle = _ref8.merchantHandle;

    if (prevMerchantHandle !== merchantHandle || prevUtmCampaign !== utmCampaign) {
      this.getBicData(true);
    }
  };

  BuyWithInstacredLandingPage.prototype.render = function render() {
    var _props = this.props,
        apiState = _props.apiState,
        uiComponents = _props.uiComponents,
        bicAction = _props.bicAction,
        matches = _props.matches;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_1_preact_compat__["Suspense"],
      { fallback: null },
      __WEBPACK_IMPORTED_MODULE_9__utils__["c" /* default */].isOrganicSite() ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(BicRevampContainer, {
        apiStatus: apiState,
        uiComponents: uiComponents,
        pageKey: this.pageKey,
        bicAction: bicAction,
        matches: matches
      }) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(BicContainer, {
        apiStatus: apiState,
        uiComponents: uiComponents,
        pageKey: this.pageKey,
        bicAction: bicAction
      })
    );
  };

  return BuyWithInstacredLandingPage;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var mapStateToProps = function mapStateToProps(_ref9) {
  var buyWithInstacred = _ref9.buyWithInstacred,
      registrationUserData = _ref9.registrationUserData;

  var _ref10 = buyWithInstacred || {},
      home = _ref10.home;

  var _ref11 = home || {},
      uiComponents = _ref11.uiComponents,
      merchantMetadata = _ref11.merchantMetadata,
      apiState = _ref11.apiState;

  var lenderId = registrationUserData.lenderId;

  var authDetails = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["g" /* getSessionStorage */])('authDetails');

  var _ref12 = authDetails ? JSON.parse(authDetails) : {},
      login = _ref12.login;

  var userRegistered = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* getLocalstorage */])('userRegistered') || '';
  var extraUiComponents = [];
  //removed temporary for Ikea-campaign with flexipay
  /*
  if (Object.keys(merchantMetadata).length) {
    extraUiComponents.push('SHOW_DEFAULT_BIC');
  }
   */
  //user-eligible-display-logic
  if (!login && userRegistered !== 'true' && (!lenderId || lenderId === 'instaCred')) {
    extraUiComponents.push('SHOW_USER_ELIGIBLE');
  }
  return {
    apiState: apiState,
    lenderId: lenderId,
    uiComponents: [].concat(uiComponents, extraUiComponents)
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, { bicAction: __WEBPACK_IMPORTED_MODULE_5__actions_bicAction__["a" /* default */], navBarConfigAction: __WEBPACK_IMPORTED_MODULE_10__actions_navBarConfigAction__["a" /* default */] })(Object(__WEBPACK_IMPORTED_MODULE_3__HOC_withBaseComponent__["a" /* default */])(BuyWithInstacredLandingPage)));

/***/ }),

/***/ "C3nP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  initializeBIC: 'initializeBIC',
  initializeBICSearch: 'initializeBICSearch',
  initializeCategory: 'initializeCategory',
  initializeMerchants: 'initializeMerchants',
  toggleFilter: 'toggleFilter',
  changeFilterStatus: 'changeFilterStatus',
  initializeTransactionHistory: 'initializeTransactionHistory',
  initializeFaqScreen: 'initializeFaqScreen',
  initializeChangePin: 'initializeChangePin',
  initializeHTB: 'initializeHTB',
  initializeVoucher: 'initializeVoucher',
  initializeLogin: 'initializeLogin',
  initializeAccountLogin: 'initializeAccountLogin',
  checkUserEligible: 'checkUserEligible',
  updateSearchText: 'updateSearchText',
  clickCategorySeeMore: 'clickCategorySeeMore',
  clickCategory: 'clickCategory',
  clickMerchantSeeMore: 'clickMerchantSeeMore',
  clickMerchant: 'clickMerchant',
  clickBrandsSeeMore: 'clickBrandsSeeMore',
  clickBrands: 'clickBrands',
  toggleSearchAndFilterCategoryPage: 'toggleSearchAndFilterCategoryPage'
});

/***/ }),

/***/ "KOqX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./actions/bicAction/actionType.js
var actionType = __webpack_require__("C3nP");

// EXTERNAL MODULE: ./components/material-ui/helper.js
var helper = __webpack_require__("Ahxv");

// EXTERNAL MODULE: ./api/controllers/buyWithInstacredController.js
var buyWithInstacredController = __webpack_require__("vILD");

// EXTERNAL MODULE: ./actionTypes/index.js
var actionTypes = __webpack_require__("9vGq");

// EXTERNAL MODULE: ./tracking/index.js
var tracking = __webpack_require__("Z0Lr");

// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__("DHvs");

// EXTERNAL MODULE: ./tracking/helper.js
var tracking_helper = __webpack_require__("btDT");

// EXTERNAL MODULE: ./constants/offerSupportLenders.js
var offerSupportLenders = __webpack_require__("kG7M");

// CONCATENATED MODULE: ./actions/bicAction/getBIC.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







/* harmony default export */ var getBIC = (function (payload) {
  return function (dispatch) {
    dispatch({ type: actionTypes["j" /* bicActionType */].GET_BIC_API_INITIATED, payload: payload });

    var _ref = payload || {},
        queryParamUserUuid = _ref.queryParamUserUuid,
        others = _objectWithoutProperties(_ref, ['queryParamUserUuid']);

    Object(buyWithInstacredController["a" /* getBICData */])(others).then(function (_ref2) {
      var respData = _ref2.data;

      if (queryParamUserUuid) {
        Object(buyWithInstacredController["k" /* setIcUserCookie */])({ uuid: queryParamUserUuid }).then(function (_ref3) {
          var respData = _ref3.data;

          if (respData && respData.identified) {
            Object(utils["l" /* setLocalStorage */])(tracking_helper["b" /* USER_UUID_COOKIE_KEY */], queryParamUserUuid);
            tracking["e" /* tracker */].pushUserProfile();
          }
        });
      }

      //This is done for making offers contextual, need to remove when we bring the data from database.
      respData && respData.offers && respData.offers.forEach(function (offer, i) {
        if (offer.handle === 'bigc') {
          offer.supportedLenders = _extends({}, offerSupportLenders["a" /* bigCOfferLenders */]);
        } else if (offer.handle === 'lotmobiles') {
          offer.supportedLenders = _extends({}, offerSupportLenders["b" /* lotMobilesOfferLenders */]);
        } else {
          offer.supportedLenders = {};
        }
      });
      return dispatch({
        type: actionTypes["j" /* bicActionType */].GET_BIC_API_SUCCESS,
        payload: respData
      });
    }).catch(function (error) {
      return dispatch({ type: actionTypes["j" /* bicActionType */].GET_BIC_API_ERROR, payload: {} });
    });
  };
});
// EXTERNAL MODULE: ./actions/checkUserEligibility/index.js
var checkUserEligibility = __webpack_require__("3cgg");

// EXTERNAL MODULE: ./alias/homeRoutes.js
var homeRoutes = __webpack_require__("hr9z");

// EXTERNAL MODULE: ./alias/activationRoutes.js
var activationRoutes = __webpack_require__("eQ4/");

// EXTERNAL MODULE: ./actions/onLogin/initiateLogin.js
var initiateLogin = __webpack_require__("SWX7");

// EXTERNAL MODULE: ./utils/routeHandler.js
var routeHandler = __webpack_require__("fupk");

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// CONCATENATED MODULE: ./actions/bicAction/userEligibleSuccessAction.js








var userEligibleSuccessAction_userEligibleSuccessAction = function userEligibleSuccessAction(responseData) {
  return function (dispatch) {
    var _ref = responseData || {},
        isEligible = _ref.isEligible,
        lenders = _ref.lenders,
        userStatus = _ref.userStatus,
        mobile = _ref.mobile;

    if (isEligible) {
      if (userStatus === 'PRE_APPROVED') {
        //redirected user to activation flow
        if (lenders) {
          var id = lenders[0];
          var lenderId = id.toString();
          return Object(preact_router_es["route"])(Object(routeHandler["b" /* generateUrlWithParams */])(activationRoutes["d" /* lenderNewUserRoute */].path, {
            lenderId: lenderId
          }));
        }
      }
      //user is eligible and needs to login
      dispatch(Object(initiateLogin["a" /* default */])({ mobile: mobile, gatewayMerchantId: null }));
      //Need to add delay so that init-login action will get called and after that mobile number will populate in URL from redux-store
      return setTimeout(function () {
        Object(preact_router_es["route"])(Object(routeHandler["b" /* generateUrlWithParams */])(homeRoutes["x" /* loginRoute */].path));
      });
    } else {
      var errorMessage = 'Entered number is not eligible. Please provide your number registered with one of our banking partners';
      dispatch({
        type: actionTypes["r" /* homeActionType */].SUD_API_ERROR,
        payload: { errorMessage: errorMessage }
      });
      var attemptsRemaining = Object(utils["e" /* getLocalstorage */])('attemptsRemaining') ? parseInt(Object(utils["e" /* getLocalstorage */])('attemptsRemaining'), 10) : 2;
      if (attemptsRemaining > 0) {
        Object(utils["l" /* setLocalStorage */])('attemptsRemaining', (attemptsRemaining - 1).toString());
        setTimeout(function () {
          dispatch({ type: actionTypes["r" /* homeActionType */].SUD_STATUS_RESET, payload: {} });
        }, 3000);
      }
    }
  };
};
// CONCATENATED MODULE: ./actions/bicAction/userEligibilityFail.js



var userEligibilityFail_userEligibleFail = function userEligibleFail() {
  return function (dispatch) {
    var errorMessage = 'System Error, Please try again later';
    dispatch({
      type: actionTypes["r" /* homeActionType */].SUD_API_ERROR,
      payload: { errorMessage: errorMessage }
    });
    var attemptsRemaining = Object(utils["e" /* getLocalstorage */])('attemptsRemaining') ? parseInt(Object(utils["e" /* getLocalstorage */])('attemptsRemaining'), 10) : 2;
    if (attemptsRemaining > 0) {
      Object(utils["l" /* setLocalStorage */])('attemptsRemaining', (attemptsRemaining - 1).toString());
      setTimeout(function () {
        dispatch({ type: actionTypes["r" /* homeActionType */].SUD_STATUS_RESET, payload: {} });
      }, 3000);
    }
  };
};
// CONCATENATED MODULE: ./actions/bicAction/index.js








/* harmony default export */ var bicAction = __webpack_exports__["a"] = (function (action, actionPayload) {
  return function (dispatch) {
    switch (action) {
      case actionType["a" /* default */].initializeBIC:
        var _ref = actionPayload || {},
            campaignId = _ref.campaignId,
            merchantHandle = _ref.merchantHandle,
            shouldFetchApi = _ref.shouldFetchApi,
            queryParamUserUuid = _ref.queryParamUserUuid;

        if (shouldFetchApi) {
          var query = {
            merchantHandle: merchantHandle,
            campaignId: campaignId,
            queryParamUserUuid: queryParamUserUuid
          };
          dispatch(getBIC(Object(helper["a" /* removeBlankKeys */])(query)));
        }
        return dispatch({ type: actionTypes["j" /* bicActionType */].INIT_BIC_SCREEN, payload: {} });
      case actionType["a" /* default */].toggleFilter:
        return dispatch({
          type: actionTypes["r" /* homeActionType */].TOGGLE_FILTER,
          payload: {}
        });
      case actionType["a" /* default */].toggleSearchAndFilterCategoryPage:
        return dispatch({
          type: actionTypes["r" /* homeActionType */].TOGGLE_SEARCH_AND_FILTER_CATEGORY,
          payload: {}
        });

      case actionType["a" /* default */].initializeFaqScreen:
        {
          var _ref2 = actionPayload || {},
              _campaignId = _ref2.campaignId,
              lenderDetails = _ref2.lenderDetails;

          if (lenderDetails) {
            dispatch({
              type: actionTypes["n" /* commonActionType */].STORE_DATA,
              payload: { lenderDetails: lenderDetails }
            });
          }
          return dispatch({
            type: actionTypes["r" /* homeActionType */].INIT_FAQ_SCREEN,
            payload: { campaignId: _campaignId }
          });
        }
      case actionType["a" /* default */].initializeChangePin:
        {
          var _ref3 = actionPayload || {},
              _campaignId2 = _ref3.campaignId;

          return dispatch({
            type: actionTypes["r" /* homeActionType */].INIT_CHANGE_PIN_SCREEN,
            payload: { campaignId: _campaignId2 }
          });
        }
      case actionType["a" /* default */].initializeHTB:
        {
          var _ref4 = actionPayload || {},
              _campaignId3 = _ref4.campaignId;

          return dispatch({
            type: actionTypes["r" /* homeActionType */].INIT_HTB_SCREEN,
            payload: { campaignId: _campaignId3 }
          });
        }
      case actionType["a" /* default */].initializeVoucher:
        {
          var _ref5 = actionPayload || {},
              _campaignId4 = _ref5.campaignId;

          return dispatch({
            type: actionTypes["r" /* homeActionType */].INIT_VOUCHER_SCREEN,
            payload: { campaignId: _campaignId4 }
          });
        }
      case actionType["a" /* default */].initializeLogin:
        {
          dispatch({
            type: actionTypes["n" /* commonActionType */].CLEAR_STORE,
            payload: {}
          });
          return setTimeout(function () {
            var _ref6 = actionPayload || {},
                campaignId = _ref6.campaignId;

            dispatch({
              type: actionTypes["r" /* homeActionType */].INIT_LOGIN_SCREEN,
              payload: { campaignId: campaignId }
            });
          });
        }
      case actionType["a" /* default */].initializeAccountLogin:
        {
          var _ref7 = actionPayload || {},
              _campaignId5 = _ref7.campaignId;

          dispatch({
            type: actionTypes["r" /* homeActionType */].INIT_ACCOUNT_SCREEN,
            payload: { campaignId: _campaignId5 }
          });
        }
      case actionType["a" /* default */].initializeTransactionHistory:
        {
          var _ref8 = actionPayload || {},
              _campaignId6 = _ref8.campaignId;

          return dispatch({
            type: actionTypes["r" /* homeActionType */].INIT_TRANSACTION_HISTORY,
            payload: { campaignId: _campaignId6 }
          });
        }
      case actionType["a" /* default */].checkUserEligible:
        var _ref9 = actionPayload || {},
            mobile = _ref9.mobile,
            ignoreCookie = _ref9.ignoreCookie,
            gatewayMerchantId = _ref9.gatewayMerchantId;

        return dispatch(Object(checkUserEligibility["a" /* default */])({ mobile: mobile, ignoreCookie: ignoreCookie, gatewayMerchantId: gatewayMerchantId }, userEligibleSuccessAction_userEligibleSuccessAction, userEligibilityFail_userEligibleFail));
      case actionType["a" /* default */].updateSearchText:
        var _ref10 = actionPayload || {},
            searchText = _ref10.searchText;

        return dispatch({
          type: actionTypes["j" /* bicActionType */].UPDATE_SEARCH_TEXT,
          payload: { searchText: searchText }
        });
      case actionType["a" /* default */].initializeBICSearch:
        {
          var _ref11 = actionPayload || {},
              _campaignId7 = _ref11.campaignId;

          return dispatch({
            type: actionTypes["j" /* bicActionType */].INIT_BIC_SEARCH_SCREEN,
            payload: { campaignId: _campaignId7 }
          });
        }
      case actionType["a" /* default */].clickCategorySeeMore:
        return dispatch({
          type: actionTypes["j" /* bicActionType */].CLICK_CATEGORY_SEE_MORE,
          payload: {
            selected: 'category'
          }
        });
      case actionType["a" /* default */].clickBrandsSeeMore:
        return dispatch({
          type: actionTypes["j" /* bicActionType */].CLICK_BRAND_SEE_MORE,
          payload: {
            selected: 'brand'
          }
        });
      case actionType["a" /* default */].clickBrands:
        var _ref12 = actionPayload || {},
            brandIds = _ref12.brandIds;

        return dispatch({
          type: actionTypes["j" /* bicActionType */].CLICK_BRAND,
          payload: { brandIds: brandIds }
        });

      default:
        return null;
    }
  };
});

/***/ }),

/***/ "P6ry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Permissions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clevertap_react__ = __webpack_require__("JDox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clevertap_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__clevertap_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("DHvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracking__ = __webpack_require__("Z0Lr");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var Permissions = function Permissions(pageKey) {
  var _this = this;

  _classCallCheck(this, Permissions);

  this.pageKey = null;
  this.pushPermissionAlreadyGranted = false;

  this.askForPushNotification = function () {
    if ('Notification' in window && Notification.permission === 'granted') {
      _this.pushPermissionAlreadyGranted = true;
    }
    var currentTime = new Date().getTime();
    var shouldAskPermission = true;
    if (__WEBPACK_IMPORTED_MODULE_1__index__["c" /* default */].isClientSideStorageEnabled()) {
      var notificationStorage = Object(__WEBPACK_IMPORTED_MODULE_1__index__["e" /* getLocalstorage */])(_this.pageKey);

      var _JSON$parse = JSON.parse(notificationStorage || JSON.stringify({ expiryTime: 0 })),
          expiryTime = _JSON$parse.expiryTime;

      shouldAskPermission = currentTime > expiryTime;
    }
    if (shouldAskPermission) {
      __WEBPACK_IMPORTED_MODULE_0__clevertap_react__["pushNotificationPermission"]('Never miss an offer to buy your favourite products', 'We will only send you notifications for great offers and sales. These can be turned off anytime.', 'Get Offers', 'Later', '#60b260', '30', '/service-worker.js', _this.trackCustomPushPermissionPopUpAllowed, _this.trackCustomPushPermissionPopUpRejected, _this.trackPushPermissionGranted);
    }
  };

  this.trackCustomPushPermissionPopUpAllowed = function () {
    __WEBPACK_IMPORTED_MODULE_2__tracking__["e" /* tracker */].trackUserInteraction(__WEBPACK_IMPORTED_MODULE_2__tracking__["c" /* UserActionType */].CLICK, 'CT Notification Pop-up Allowed', _this.pageKey);
  };

  this.trackCustomPushPermissionPopUpRejected = function () {
    var expiryTime = new Date().getTime() + 48 * 60 * 60 * 1000; //48 hrs of expiry period has been added
    if (__WEBPACK_IMPORTED_MODULE_1__index__["c" /* default */].isClientSideStorageEnabled()) {
      var notificationStorage = {
        notification: true,
        expiryTime: expiryTime
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__index__["l" /* setLocalStorage */])(_this.pageKey, JSON.stringify(notificationStorage));
    }
    __WEBPACK_IMPORTED_MODULE_2__tracking__["e" /* tracker */].trackUserInteraction(__WEBPACK_IMPORTED_MODULE_2__tracking__["c" /* UserActionType */].CLICK, 'CT Notification Pop-up Rejected', _this.pageKey);
  };

  this.trackPushPermissionGranted = function () {
    if (!_this.pushPermissionAlreadyGranted) {
      __WEBPACK_IMPORTED_MODULE_2__tracking__["e" /* tracker */].trackUserInteraction(__WEBPACK_IMPORTED_MODULE_2__tracking__["c" /* UserActionType */].CLICK, 'Notification Permission Granted', _this.pageKey);
    }
  };

  this.pageKey = pageKey;
};



/***/ }),

/***/ "eGlY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__("9vGq");


/* harmony default export */ __webpack_exports__["a"] = (function (action, actionPayload) {
  return function (dispatch) {
    switch (action) {
      case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["z" /* navBarConfigActionType */].SET_CONFIG:
        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["z" /* navBarConfigActionType */].SET_CONFIG,
          payload: {
            titleText: actionPayload.titleText,
            showBackBtn: actionPayload.showBackBtn,
            showDesktopNavMenu: actionPayload.showDesktopNavMenu,
            showDesktopSearchBar: actionPayload.showDesktopSearchBar,
            showMobileSearchIcon: actionPayload.showMobileSearchIcon
          }
        });
        break;
      case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["z" /* navBarConfigActionType */].RESET:
        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["z" /* navBarConfigActionType */].RESET,
          payload: {}
        });
        break;
      default:
        return null;
    }
  };
});

/***/ }),

/***/ "kG7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return offerSupportLenders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bigCOfferLenders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lotMobilesOfferLenders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sangeethaOfferLenders; });
var offerSupportLenders = {
  401: { lenderId: 401, logo: 'https://iccdn.in/img/kotak-icon-v1.png' },
  701: {
    lenderId: 701,
    logo: 'https://iccdn.in/lenders/icici-icon-logo-v4.svg'
  },
  501: {
    lenderId: 501,
    logo: 'https://iccdn.in/img/hdfc-logo-icon-v2.png'
  },
  201: {
    lenderId: 201,
    logo: 'https://iccdn.in/img/idfc-first-icon-v1.png'
  }
};

var bigCOfferLenders = {
  401: true,
  701: true,
  501: true,
  201: true
};

var lotMobilesOfferLenders = {
  401: true,
  701: true,
  501: true,
  201: true
};

var sangeethaOfferLenders = {
  401: true,
  701: true,
  501: true,
  201: true
};

/***/ })

});


// WEBPACK FOOTER //
// route-buy-with-instacred-landing.chunk.3b2e5.js